import { Reducer } from 'redux';
import { MachineType } from "models/MachineType";
import { IMachineTypeActions, MachineTypeActionType } from "redux/actions/settings/MachineTypeActions";

const initialState: MachineType[] | null = null;
export const machineTypesReducer: Reducer<MachineType[] | null, IMachineTypeActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachineTypeActionType.FETCH_MACHINETYPES_SUCCESS:
                {
                    return action.returnPayload as MachineType[];
                }
            case MachineTypeActionType.ADD_MACHINETYPE_SUCCESS:
                {
                    let newMachineTypes = [...state!];
                    newMachineTypes.push({ ...action.returnPayload } as MachineType)
                    return newMachineTypes;
                }
            case MachineTypeActionType.EDIT_MACHINETYPE_SUCCESS:
            case MachineTypeActionType.DELETE_MACHINETYPE_SUCCESS:
                {
                    let newManufs = [...state!];
                    const updatedMachineType = { ...action.returnPayload } as MachineType;
                    newManufs = newManufs.map(nm => nm.id === updatedMachineType.id ? updatedMachineType : nm);
                    return newManufs;
                }
            default:
                return state;
        }
    };
